import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=ac31cc5a&scoped=true&"
import script from "./Chips.vue?vue&type=script&lang=js&"
export * from "./Chips.vue?vue&type=script&lang=js&"
import style0 from "./Chips.vue?vue&type=style&index=0&id=ac31cc5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac31cc5a",
  null
  
)

export default component.exports